import { render, staticRenderFns } from "./HeadBack.vue?vue&type=template&id=1e32c33e&scoped=true"
import script from "./HeadBack.vue?vue&type=script&lang=js"
export * from "./HeadBack.vue?vue&type=script&lang=js"
import style0 from "./HeadBack.vue?vue&type=style&index=0&id=1e32c33e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e32c33e",
  null
  
)

export default component.exports